import { mapSetFormatBase } from "../FsSetFormat";
import { TimeAttackFormat } from "model/Match/Set/TimeAttack/TimeAttackFormat";
import { mapTimeAttackScoring } from "./Scoring/FsTimeAttackScoring";
import { FsTimeAttackFormat } from "db/model/match/Set/TimeAttack/FsTimeAttackFormat";

export const mapTimeAttackFormat = (
  fsModel: FsTimeAttackFormat
): TimeAttackFormat | undefined => {
  const base = mapSetFormatBase(fsModel);
  if (!base || !fsModel.numTracks || !fsModel.scoring) {
    return undefined;
  }

  const scoring = mapTimeAttackScoring(fsModel.scoring);
  if (!scoring) {
    return undefined;
  }

  return {
    ...base,
    numTracks: fsModel.numTracks,
    scoring,
    sumTrackScores: fsModel.sumTrackScores,
    lowerBetter: fsModel.lowerBetter,
  };
};
